import { __rest } from "tslib";
import React, { createContext, useContext, useMemo } from "react";
export var JSON_CONTEXT_DATA_ID = "vseth-context-data";
var defaultContext = {
  globID: "vseth-0000-vseth",
  static_url: "https://static.vseth.ethz.ch",
  environment: "extern"
};
export var ReactVSETHContext = /*#__PURE__*/createContext(defaultContext);
export var VSETHContext = function (_a) {
  var children = _a.children,
      arg = __rest(_a, ["children"]);

  var serverData = useMemo(function () {
    // Needed because of SSR
    if (typeof window !== "undefined") {
      var el = document.getElementById(JSON_CONTEXT_DATA_ID);
      if (el === null) return undefined;

      try {
        var data_1 = JSON.parse(el.textContent || "");
        return data_1;
      } catch (e) {
        return undefined;
      }
    }

    return undefined;
  }, []);
  var data = useMemo(function () {
    return {
      globID: arg.globID || (serverData === null || serverData === void 0 ? void 0 : serverData.globID) || defaultContext.globID,
      static_url: arg.static_url || (serverData === null || serverData === void 0 ? void 0 : serverData.static_url) || defaultContext.static_url,
      environment: arg.environment || (serverData === null || serverData === void 0 ? void 0 : serverData.environment) || defaultContext.environment
    };
  }, [serverData, arg.globID, arg.environment, arg.static_url, defaultContext]);
  return React.createElement(ReactVSETHContext.Provider, {
    value: data
  }, children);
};
export var useVSETHContext = function () {
  return useContext(ReactVSETHContext);
};